import GoogleAdUnit from "../../components/GoogleAdUnit";
import { ADSENSE_IN_FEED_LAYOUT_KEY } from "../../utility/googleAds";

const Advertisement = () => {
    return (
        <div className="advertisementview mb-3">
            <div
                className="advertisementContainer"
                style={{
                    width: "100%",
                    height: "300px",
                    overflow: "hidden",
                    margin: "20px auto",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <GoogleAdUnit
                    adSlot="7349331462"
                    layoutKey={ADSENSE_IN_FEED_LAYOUT_KEY}
                    style={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                    }}
                />
            </div>
        </div>
    );
};

export default Advertisement;
